const removeFirstMatchingItemFromArray = <T>(items: Array<T>, itemToRemove: T): void => {
  const index: number = items.indexOf(itemToRemove);

  if (index !== -1) {
    items.splice(index, 1);
  }
};

export default removeFirstMatchingItemFromArray;
